import React, {useState} from 'react';

const DropdownButtonSelect = ({buttonAction, placement, buttonGroupClass, buttonClass, disabledClass, disabled, icon,
    singleAction, buttonTriggerClass, showDividerAfter, nameObject, listData, initialItem, useKeyField, keyField, defaultText}) => {   

    // Working data
    const [isOpen, setIsOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(listData ? listData.find(x => x.itemID == initialItem) : null);
    const [buttonText, setButtonText] = useState(defaultText ? defaultText : listData ? listData.find(x => x.itemID == initialItem)[nameObject] : "");

    const buttonClick = () => {
        if(singleAction){
            onSelect();
        }
        else {
            if (useKeyField){                                 
                buttonAction({ item: selectedItem[keyField] });
            }
            else{
                buttonAction({ item: selectedItem });
            }
            setIsOpen(false);
        }
    }

    const onSelect = () => {
        setIsOpen(!isOpen);
    }

    const onSelectItem = (item) => {
        if(singleAction){                                            
            if (useKeyField){                                 
                buttonAction({ item: item[keyField] });
            }
            else{
                buttonAction({ item: item });
            }
        }
        setButtonText(item[nameObject]);
        setSelectedItem(item);
        setIsOpen(false);
    }

    return (       
        <div className={`ci-button-group ci-dropdown drop-${placement} ${buttonGroupClass} ${isOpen ? "open" : ""}`}>
            <button className={`button ${buttonClass} ${disabledClass}`} onClick={buttonClick} disabled={disabled}>
                {icon && <i className={icon}> </i>}
                {buttonText} 
                {singleAction && <span className="caret"></span>}
            </button>
            {listData && listData.length > 0 && !singleAction && <button className={`button ${buttonTriggerClass} ${disabledClass} no-text`} onClick={onSelect} disabled={disabled}>
                <span className="caret"></span>
            </button>}
            <div className="ci-dropdown-container">
                <ul className="no-style">
                    {listData.map((item,i) => 
                        <li key={i} className={`list-item ${selectedItem.itemID == item.itemID ? "selected" : ""}`}>
                            <a onClick={() => onSelectItem(item)}><span className="normal">{item[nameObject]}</span></a>
                            {showDividerAfter && <div className="custom-dropdown-divider"></div>}
                        </li>
                    )}
                </ul>
            </div>
        </div>    
    );
};

export default DropdownButtonSelect;
